// extracted by mini-css-extract-plugin
export default {"button":"Button_button__kic8G","loadingSpan":"Button_loadingSpan__rARs2","spin":"Button_spin__XeOMD"};